import { sharingToken } from '@/utils/appinfo/sharingtoken'
import synowebapi from '@synology/synowebapi'
import synowebrtc from '@synology/synowebrtc'
import { serverDriveSharingLink } from '@/utils/serverInject'

const drivewebapi = {
  async init() {
    synowebrtc.SetSynoWebAPI(synowebapi)
    synowebrtc.Enable = synowebrtc.IsRelay

    const webapiConfig = {
      api: 'SYNO.SynologyDrive.Shard',
      method: 'init',
      version: 1,
      params: {
      },
    }

    return await this.sendSynoWebapi(webapiConfig)
  },

  async notifyUploadComplete(notifyCfg, uploadItems, abortController) {
    const driveApiConfig = {
      api: 'SYNO.SynologyDrive.FileRequest.Public',
      method: 'notify',
      version: 1,
      params: {
        uploader: notifyCfg.uploader,
        request_title: notifyCfg.request_title,
        upload_items: uploadItems,
        path: `id:${notifyCfg.file_id}`,
        sharing_token: sharingToken(),
      }
    }

    if (abortController) {
      driveApiConfig.signal = abortController.signal
    }

    return await this.sendSynoWebapi(driveApiConfig)
  },

  async getRequestInfo(abortController) {
    const driveApiConfig = {
      api: 'SYNO.SynologyDrive.FileRequest.Public',
      method: 'get',
      version: 1,
      params: {
        sharing_link: serverDriveSharingLink(),
        sharing_token: sharingToken(),
      },
    }

    if (abortController) {
      driveApiConfig.signal = abortController.signal
    }

    return await this.sendSynoWebapi(driveApiConfig)
  },

  async createFolder(parentId, folderName, conflictAction) {
    const driveApiConfig = {
      api: 'SYNO.SynologyDrive.Files',
      method: 'create',
      version: 2,
      params: {
        type: 'folder',
        path: `id:${parentId}/${folderName}`,
        conflict_action: conflictAction,
        sharing_token: sharingToken(),
        sharing_type: 'file_request',
      },
    }

    return await this.sendSynoWebapi(driveApiConfig)
  },

  async authFileRequestPassword(password) {
    const driveApiConfig = {
      api: 'SYNO.SynologyDrive.FileRequest.Public',
      method: 'auth',
      version: 1,
      params: {
        password,
        encryption: ['password'],
        sharing_link: serverDriveSharingLink(),
      },
    }

    return await this.sendSynoWebapi(driveApiConfig)
  },

  async upload(uploadParam) {
    const formData = new FormData()
    formData.append('modified_time', uploadParam.lastModified / 1000)
    formData.append('mute', false)
    formData.append('sharing_token', sharingToken())
    formData.append('sharing_type', 'file_request')
    formData.append('file', uploadParam.fileContent)

    const uploadConfig = {
      api: 'SYNO.SynologyDrive.Files',
      method: 'upload',
      version: 2,
      params: {
        path: `id:${uploadParam.targetId}/${uploadParam.relativePath}`,
        conflict_action: uploadParam.conflictAction,
        type: 'file',
        json_error: true,
      },
      formData: formData,
      headers: {
        'X-TMP-FILE': uploadParam.uploadId.slice(0, 32), // to match the length of the tmpFile in the original code
        'X-TYPE-NAME': 'SLICEUPLOAD',
        'X-FILE-CHUNK-END': 'true',
      }
    }

    if (uploadParam.isDryRun) {
      Object.assign(uploadConfig.params, {
        reserved_size: uploadParam.uploadTargetFile.size
      })
      Object.assign(uploadConfig.headers, {
        'X-FILE-CHUNK-END': 'false',
      })
    }

    return await this.sendSynoWebapi(uploadConfig)
  },

  setSynoToken(synoToken) {
    synowebapi.env.setSynoToken(synoToken)
  },

  sendSynoWebapi(driveApiConfig) {
    return synowebapi.promises.request(driveApiConfig)
  },
}

export default drivewebapi
